import { render, staticRenderFns } from "./NewsletterSubscription.vue?vue&type=template&id=2e98ed6a"
import script from "./NewsletterSubscription.vue?vue&type=script&lang=js"
export * from "./NewsletterSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports